module.exports = "pegasus/assets/themelp1/small/26.png";